import * as React from "react";

import "./menu-layout.scss";

export const MenuLayout = ({title, button, next}) => (
    <div className="menu-layout-e8t">
        <div className="title" xd-qa-type="label" xd-qa-name="title">
            {title}
        </div>
        <div className="content">
            {next()}
        </div>
        {button && <button
            className="primary"
            onClick={button.onClick}
            disabled={button.disabled}
            xd-qa-type="button"
            xd-qa-name="Save"
        >
            Save
        </button>}
    </div>
);